
// Import utils
import { isEmpty } from '@automator/shared/utils/is-empty';

/**
 * Checks if an integration has universal tokens
 *
 * @param {Object} integration An integration.
 * @return {Boolean} Whether the integration has universal tokens.
 */
const integrationHasUniversalTokens = ( integration ) => {
	// Check if the integration has universal tokens.
	return ! isEmpty( integration.tokens );
}

export default integrationHasUniversalTokens;
